import { IControleDebitosResponseItem } from "../ports/ControleDebitosGateway";
import EmpresaMapper from "@/features/contabil/common/EmpresaMapperAdapter";
import ControleDebito from "../entities/ControleDebito";
import Debito from "../entities/Debito";
import SaldoDevedor from "../entities/SaldoDevedor";

export default class ControleDebitoMapperAdapter {
  static toEntity(value: IControleDebitosResponseItem): ControleDebito {
    const empresa = EmpresaMapper.toEntity(value.empresa);

    const debitos = value.debitos;

    const controle = ControleDebito.create({
      empresa,
      debitos: debitos.map((debito) => {
        return Debito.create({
          periodoApuracao: debito.periodoApuracao,
          dataVencimento: debito.dataVencimento,
          debitoDeclarado: debito.debitoDeclarado,
          saldoDevedor: SaldoDevedor.create({
            juros: debito.saldoDevedor.juros,
            multa: debito.saldoDevedor.multa,
            principal: debito.saldoDevedor.principal,
            total: debito.saldoDevedor.total
          }),
          parcelamento: debito.parcelamento
        });
      })
    });

    return controle;
  }
}
